var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-card-text',{staticClass:"px-0"},[_c('v-simple-table',{staticClass:"wgu-proptable"},[_c('tbody',{staticClass:"attr-tbody"},_vm._l((_vm.properties),function(value,key){return _c('tr',{key:key},[_c('td',{staticClass:"key-td"},[_vm._v("\n          "+_vm._s(key)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"val-td",domProps:{"innerHTML":_vm._s(value)}})])}),0)])],1):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01127237","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/infoclick/PropertyTable.vue
// module id = bkd3
// module chunks = 1